export default function getWindowKeys(windowKeys) {
  var stateObjToUpdate = {...windowKeys};
  var objKeys = Object.keys(stateObjToUpdate);
  objKeys.splice(objKeys.indexOf('rowCount'), 1);
  objKeys.splice(objKeys.indexOf('columnCount'), 1);
  return objKeys;
};